import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static bodyModalClass = "generic-modal-open"
  static targets = ["modal", "openButton"]

  disconnect() {
    this.unlockBodyScroll()
  }

  open(event) {
    event.preventDefault()
    if (!this.hasModalTarget) return

    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    this.lockBodyScroll()

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", "true")
    }
  }

  close(event) {
    if (event && !(event.currentTarget instanceof HTMLAnchorElement)) {
      event.preventDefault()
    }
    if (!this.hasModalTarget) return

    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    this.unlockBodyScroll()

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", "false")
    }
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  lockBodyScroll() {
    document.body.classList.add(this.constructor.bodyModalClass)
  }

  unlockBodyScroll() {
    document.body.classList.remove(this.constructor.bodyModalClass)
  }
}
